
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

export interface Endtest {

    Id: string;
    Test_Taker_User_Id : string;
    Is_Logged : string;
    login_time: string;
    logoff_time: string;
    schedule_master_Id: string;
    // options:Array<Overall_Result>;
  }

  export interface Check_log_value {


    Test_Taker_User_Id : string;
    schedule_id: string;

    // options:Array<Overall_Result>;
  }

  export interface evaluate_user{
    id:string;
  }
  export interface formData{
    data:string;
  }
  interface TokenResponse {
    token: string;

  }

@Injectable()
export class endtestService {
    private token: string;

  constructor(private http: HttpClient) {}



  public endtest(user:Endtest,user_id:any,schedule_master:any): Observable<any> {

    // var body = {
    //   id:id
    // }
    var body ={
      user:user,
      user_id:user_id,
      schedule_master:schedule_master
    }
    const base = this.http.post('/users/time/logout_time',body);
    const request = base.pipe(
      map((data: TokenResponse) => {

          return data;
      })
    );
    return request;
  }

  public updatelogin(user:Endtest,user_id:any,schedule_id:any): Observable<any> {

    // var body = {
    //   id:id
    // }
    var body ={
      user:user,
      user_id:user_id,
      schedule_id:schedule_id
    }
    console.log("body inside update Login",body)
    const base = this.http.post('/users/login/update_login',body);
    const request = base.pipe(
      map((data: TokenResponse) => {

          return data;
      })
    );
    return request;
  }

  public checkisLogged(user:Check_log_value): Observable<any> {

    // var body = {
    //   id:id
    // }
    const base = this.http.post('/users/terminate/check_islogged',user);
    const request = base.pipe(
      map((data: TokenResponse) => {

          return data;
      })
    );
    return request;
  }

  // public upload_question(user:formData): Observable<any> {
  //
  //   // var body = {
  //   //   id:id
  //   // }
  //   const base =  this.http.post('/users/upload_questionbank', user)
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //         return data;
  //     })
  //   );
  //   return request;
  // }

  public evaluate(userId:any,schedule_id:any): Observable<any> {

    var body = {
      id: userId,
      schedule_id:schedule_id
    };
    console.log("body inside evaluate",body)
    const b = this.http.post('/users/evaluate',body);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

// question category
// public category(user: Category): Observable<any> {
//
//     const base = this.http.post('/users/category', user);
//
//     const request = base.pipe(
//       map((data: TokenResponse) => {
//
//
//         // if (data.token) {
//         //   this.saveToken(data.token);
//         // }
//         return data;
//       })
//     );
//     return request;
//   }



}


